import FormBlock from '../../components/form/FormBlock.tsx';
import { Secret, UpdateSecretValueRequest } from '../../api/model.ts';
import { Typography } from '@mui/material';
import { JSONSchema7 } from 'json-schema';
import useSecret from 'api/secrets/useSecret.ts';

const schema: JSONSchema7 = {
  type: 'object',
  properties: {
    value: {
      type: 'string',
      title: 'Value',
    },
  },
  required: ['value'],
};

const FORM_ID = 'EDIT_SECRET_VALUE_FORM';

type Props = {
  secret: Secret;
  onCancel: () => void;
  onSubmit: (value: string) => void;
};

const SecretValueEdit = ({ secret, onCancel, onSubmit }: Props) => {
  const { updateValue } = useSecret({ secretId: secret.id, secret });

  const handleSubmit = async (formData: UpdateSecretValueRequest) => {
    const secret = await updateValue.mutateAsync(formData);
    onSubmit(secret.value);
  };

  return (
    <div className="flex gap-2 flex-col">
      <Typography variant="h5">Edit Secret Value</Typography>
      <div className="w-full">
        <FormBlock
          formId={FORM_ID}
          onSubmit={(formData: UpdateSecretValueRequest) => void handleSubmit(formData)}
          onCancel={onCancel}
          schema={schema}
          isLoading={updateValue.isPending}
          initialValues={{ value: '' }}
        ></FormBlock>
      </div>
    </div>
  );
};

export default SecretValueEdit;
